<template>
	<div>
		<!-- breadcrumb area -->
		<div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${bgImg})`}">
		    <div class="container">
		        <div class="breadcrumb-content text-center">
		            <h2>联系我们</h2>
		        </div>
		    </div>
		</div>
		<!-- Project area -->
		<div class="section section-padding">
		    <div class="container">
		        <div class="row">
		            <div class="col-lg-4 col-md-6">
		                <div class="contact-info-wrap">
		                    <div class="single-contact-info-wrap">
		                        <div class="info-icon">
		                            <i class="dlicon ui-1_home-51"></i>
		                        </div>
		                        <div class="info-content">
		                            <h3 class="title" style="color: #4A4A4A;">企业地址</h3>
		                            <p>深圳市龙岗区坂田街道<br/>坂田国际中心A座1508号</p>
		                        </div>
		                    </div>
		                    <div class="single-contact-info-wrap">
		                        <div class="info-icon">
		                            <i class="dlicon ui-2_phone"></i>
		                        </div>
		                        <div class="info-content">
		                            <h3 class="title" style="color: #4A4A4A;">手机号码</h3>
		                            <p> 手机号: <span>13652413182</span></p>
		                            <p> 服务热线: <span>0755-83065200</span></p>
		                        </div>
		                    </div>
		                </div>
		            </div>
		            <div class="col-lg-8 col-md-6">
		                <div class="contact-from-wrap">
							<h5 style="margin-bottom: 20px;color: #4A4A4A;">
								筑壳，一个全新的场景化建筑设计装饰内容发现中心期待您的加入！
							</h5>
		                    <form id="contact-form" action="" method="post">
								<Input v-model="phone" size="large" placeholder="请输入认证手机号"  />
								<Select v-model="cate_id" size="large" style="height:50px;margin-bottom: 20px;">
									<Option v-for="item in cateList" :value="item.id" :key="item.id">{{ item.cate_name }}</Option>
								</Select>
		                        <Button type="success" long  size="large" @click="userApply">提交申请</Button>
		                    </form>
		                    <p class="form-messege"></p>
		                </div>
		            </div>
		        </div>
		    </div>
		</div>
		
	</div>
</template>

<script>
	import { getCookies, removeCookies } from '@/libs/util'
	import {
		getExhibitionList,
		userApply
	 } from '@/api'
	 export default {
	   data() {
			return {
				nameInfo: '',
				bgImg: require('../static/images/banner/banner-3.jpg'),
				cateList: [
					{id: 1,  cate_name: "设计公司"},
					{id: 2,  cate_name: "装修公司"},
					{id: 3,  cate_name: "材料供应商"},
					{id: 4,  cate_name: "咨询/顾问公司"}
				],
				
				phone: '',
				cate_id: ''
			}
		},
		created() {
		    this.getExhibitionList()
		},
		computed: {
			isLogin() {
			  return getCookies("webtoken");
			},
		},
		methods:{
			
			// 获取会展列表
			async getExhibitionList() {
			  const res = await getExhibitionList()
			  this.exhibitionList = res.data
			},
			
			// 提交认证
			async userApply() {
				if(!this.isLogin) {
					alert('请登录后操作')
					return false
				}
			if (!this.phone) {
				alert('请填写手机号码')
				return  
			}
			if (!/^1(3|4|5|7|8|9|6)\d{9}$/i.test(this.phone)) {
				alert('请输入正确的手机号码')
				return 
			}
			if(!this.cate_id) {
				alert('请选择入驻类型')
				return 
			}
				await userApply({
					phone: this.phone,
					cate_id: this.cate_id.toString()
				}).then(res => {
					this.$Message.success(res.msg);
					this.phone = ''
					this.cate_id = ''
				}).catch(err => {
					this.$Message.success(err.msg);
					this.phone = ''
					this.cate_id = ''
				})
			},
			
		}
	}
</script>

<style>
</style>
